import { render } from "./process-reports.view.vue?vue&type=template&id=578869d7&scoped=true&ts=true"
import script from "./process-reports.view.vue?vue&type=script&lang=ts"
export * from "./process-reports.view.vue?vue&type=script&lang=ts"

import "./process-reports.view.vue?vue&type=style&index=0&id=578869d7&lang=scss&scoped=true"
import "./process-reports.view.vue?vue&type=style&index=1&id=578869d7&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578869d7"]])

export default __exports__